var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-field",
    _vm._b(
      {
        directives: [
          { name: "mask", rawName: "v-mask", value: "##", expression: "'##'" }
        ],
        attrs: {
          stretch: _vm.stretch,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          id: _vm.id,
          name: _vm.name,
          placeholder: _vm.placeholder
        },
        model: {
          value: _vm.modelValue,
          callback: function($$v) {
            _vm.modelValue = $$v
          },
          expression: "modelValue"
        }
      },
      "input-field",
      _vm.$attrs,
      false
    ),
    [
      _vm._t("default"),
      _vm._v(" " + _vm._s(_vm.periodo) + "-" + _vm._s(_vm.mes) + "-\n")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09c89c5c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c89c5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/DatePicker2.vue
// module id = 531
// module chunks = 0